import * as yup from 'yup';
import TranslationHelper from '../../../../../helpers/TranslationHelper';
import { FIELD_REQUIRED } from '@/app/constants/yup';
import { DEVICE_TYPES } from '../types';

export const getDataValidationSchema = (mode: 'edit' | 'create') =>
    yup.object().shape({
        id:
            mode === 'create'
                ? yup.string().when('autoGenerateId', {
                      is: false,
                      then: (schema) =>
                          schema.required(() =>
                              TranslationHelper.translate(FIELD_REQUIRED)
                          ),
                      otherwise: (schema) => schema.notRequired(),
                  })
                : yup.string().strip(),

        deviceType:
            mode === 'create'
                ? yup
                      .string()
                      .required(() =>
                          TranslationHelper.translate(FIELD_REQUIRED)
                      )
                : yup.string().strip(),

        serialNumber: yup
            .string()
            .required(() => TranslationHelper.translate(FIELD_REQUIRED)),

        password: yup.string().when(['deviceType'], {
            is: (deviceType: string) => {
                const canSetPassword = DEVICE_TYPES.find(
                    (d) => d.id === deviceType
                )?.canSetPassword;

                return mode === 'create' && canSetPassword !== false;
            },
            then: (schema) =>
                schema
                    .required(() => TranslationHelper.translate(FIELD_REQUIRED))
                    .max(
                        64,
                        TranslationHelper.translate(
                            'Password cannot be longer than 64 characters'
                        )
                    )
                    .matches(
                        /^\S*$/,
                        TranslationHelper.translate(
                            'Password cannot contain blank spaces'
                        )
                    )
                    .oneOf(
                        [yup.ref('passwordConfirmation'), null],
                        TranslationHelper.translate(
                            'Password and confirm password do not match'
                        )
                    ),
            otherwise: (schema) =>
                schema
                    .oneOf(
                        [yup.ref('passwordConfirmation'), null],
                        TranslationHelper.translate(
                            'Password and confirm password do not match'
                        )
                    )
                    .max(
                        64,
                        TranslationHelper.translate(
                            'Password cannot be longer than 64 characters'
                        )
                    )
                    .matches(
                        /^\S*$/,
                        TranslationHelper.translate(
                            'Password cannot contain blank spaces'
                        )
                    ),
        }),

        passwordConfirmation: yup.string().when('password', {
            is: (val: string | undefined) => !!val,
            then: (schema) =>
                schema.required(() =>
                    TranslationHelper.translate(FIELD_REQUIRED)
                ),
            otherwise: (schema) => schema.notRequired(),
        }),
    });
